import React from 'react';
import ReactGA from 'react-ga';
import './../../style/ProductInfo.css';
import pro01 from './../../images/product/product01.png'
import pro02 from './../../images/product/product02.png'
import pro03 from './../../images/product/product03.png'
import pro04 from './../../images/product/product04.png'
import download from './../../images/icon/ic_download_b.png'
/* 
::TODO
 - 기능 정의 해야함
 1. 기본 촬영
 2. 동영상
 3. 필터
 4. 강아지 디텍션
*/

class ProductInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            focused : 0,
            style : '',
            items: [
               {id: 0, item: pro01},
               {id: 1, item: pro02},
               {id: 2, item: pro03},
               {id: 3, item: pro04}
           ]
        }
        this.clicked = this.clicked.bind(this);
   }
   handleClick(key) {
        ReactGA.event({
            category: 'WEB',
            action: 'app store-2',
        });
    }

    clicked(index) {
        this.setState({focused: index});
        this.setState({style: "focused"});
        console.log('this is:', this.state.focused);
    }

    render() {
        return (
            <div className="product-info-section">
                <div className="product-info">
                    <div className="image-area">
                        <img src={pro01} id="product_img" alt="img"/>
                    </div>
                    <div className="text-area">
                        <h2>여기보시개~~</h2>
                        <h1>강아지 견생샷!</h1>
                        <p>쳐다도 안보던 우리집 댕댕이가 달라졌다.</p>
                        <p>우리집 강아지 사진 난 멍카로 찍는다.</p>
                        <p>애견인들의 완소 아이템</p>
                        <p>강아지와 셀카 찍기 힘드셨나요?</p>
                        <p>장난감 소리, 휘파람 소리 등 강아지들이</p>
                        <p>좋아하는 소리로 카메라를 응시하게 만드세요.</p>
                        <p className="c-gray">다양한 소리는 계속 업데이트 됩니다.</p>
                        <p className="c-gray">종모양의 아이콘을 클릭하면 소리가 랜덤으로 재생됩니다.</p>
                        <p className="c-gray">카메라 화면의 위/아래로 스와이핑하여 on/off 할 수 있습니다.</p>
                    </div>
                </div>
                <div className="product-info02">
                    <div className="text-area">
                        <h2>색감보정 명의</h2>
                        <h1>고화질 라이브 필터</h1>
                        <p>엄선하여 뽑은 8개의 고화질 필터로</p>
                        <p>사진과 비디오를 촬영하고 편집 할 수 있습니다.</p>
                        <p>필요에 따라 4:3, 1:1 사이즈를 선택해보세요.</p>
                        <p>확대/축소 기능을 사용하여 재밌는 영상을 담아보세요.</p>
                        <p>멍카는 셔터 소리에 지친 강아지들을 위해 무음 카메라를 제공합니다.</p>
                    </div>
                    <div className="image-area">
                        <img src={pro02} id="product_img" alt="img"/>
                    </div>
                </div>
                <div className="product-info03">
                    <div className="image-area">
                        <img src={pro03} id="product_img" alt="img"/>
                    </div>
                    <div className="text-area">
                        <h2>편집하고 바로 올리자</h2>
                        <h1>쉽고 간편한 SNS 공유</h1>
                        <p>편집한 사진과 동영상을</p>
                        <p>페이스북 인스타그램, 카카오톡 등에 쉽게 공유하세요.</p>
                        <p>앨범에서 사진과 동영상을 편집 할 수 있습니다.</p>
                        <a target="_blank" onClick={()=>{this.handleClick(1)}} href="https://itunes.apple.com/kr/app/meongca/id1369505051?l=en&mt=8">
                            <img className="btn-download" src={download} alt="download button"/>
                        </a>
                    </div>
                    <div>
                    <img src={pro04} id="product_img" alt="img"/>
                    </div>
                </div>
            </div>
        )
    }


}

export default ProductInfo;


// WEBPACK FOOTER //
// ./src/components/container/ProductInfo.js